/**
 * Action Center router (`/actions/*`).
 *
 * The sidebar exposes a single "Action Center" entry (it lands on `queue`).
 * Moving between the four surfaces — Queue, History, Auto-Approval Rules,
 * Approval Settings — happens via the in-page `<ActionCenterTabs />` strip that
 * each sub-page renders, so every surface stays deep-linkable while the nav
 * shows just one entry. This component owns the outer page chrome
 * (PageWrapperMain → SubPageContentHolder) and routes to the active sub-page.
 */
import { Routes, Route, Navigate } from 'react-router-dom';
import PageWrapperMain from '../../components/page-wrappers/PageWrapperMain';
import SubPageContentHolder from '../../components/subPageContentHolder/SubPageContentHolder';
import ActionQueue from './actionQueue/ActionQueue';
import ActionHistory from './actionHistory/ActionHistory';
import ActionRules from './actionSettings/ActionRules';

const ActionsPage = () => {
  return (
    <PageWrapperMain>
      <div className='subPage'>
        <SubPageContentHolder>
          <Routes>
            <Route path='queue' element={<ActionQueue />} />
            {/* #9 — History is hidden from the tab strip but still resolves by
                direct URL (no nav entry points at it). */}
            <Route path='history' element={<ActionHistory />} />
            <Route path='rules' element={<ActionRules />} />
            {/* #12 — Approval Settings was removed (superseded by Auto-Approval
                Rules). Its old deep-links (/actions/approval-settings,
                /actions/settings) fall through to the queue below. */}
            <Route path='*' element={<Navigate to='queue' />} />
          </Routes>
        </SubPageContentHolder>
      </div>
    </PageWrapperMain>
  );
};

export default ActionsPage;
